import builder from '../builder';
import LightBulb1 from '../../streamline-icons/light/light-bulb-1.svg';

export default builder('IconLightBulb1Light', LightBulb1);
